import React from "react";

import {
  MainBox,
  SubBox,
  HeaderTypography,
  MaintenanceImage,
  ContentTypography,
} from "./styles/maintenance";

type Props = {
  page: string;
};

const MaintenanceBlock: React.FC<Props> = ({ page }) => {
  return (
    <MainBox>
      <SubBox>
        <MaintenanceImage src="/maintenanceimg.png" style={{ marginBottom: "30px" }} />
        <HeaderTypography>This page is currently under maintenance</HeaderTypography>
        <ContentTypography>
          You may still contact your broker or support if you need further assistance.{" "}
        </ContentTypography>
      </SubBox>
    </MainBox>
  );
};

export default MaintenanceBlock;
